import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Grid from '@mui/material/Grid';

import Sidebar from 'components/Sidebar/Sidebar';
import AuthNavbar from 'components/Navbars/AuthNavbar.js';
import Home from 'pages/Home';
import UploadPost from 'pages/UploadPost';
import Thema from 'pages/Thema';

import IsLogin from './IsLogin';

function Account() {
  return (
    <div className='bg-color-lightgrey '>
      <Grid container>
        <Grid item xl={2} lg={2} md={3} sm={12} xs={12}>
          <Sidebar />
        </Grid>

        <Grid item xl={10} lg={10} md={9} sm={12} xs={12}>
          <main>
            <AuthNavbar />
            <section className='relative w-full py-10 pt-20 h-full bg-color-lightgrey  '>
              <Routes>
                <Route>
                  <Route element={<IsLogin />}>
                    <Route path='post' element={<UploadPost />} />
                  </Route>

                  <Route path='home' element={<Home />} />

                  <Route path='thema' element={<Thema />} />
                </Route>
              </Routes>
            </section>
          </main>
        </Grid>
      </Grid>
    </div>
  );
}

export default Account;
